import { render, staticRenderFns } from "./ListaAulas.vue?vue&type=template&id=662b0a97&scoped=true&"
import script from "./ListaAulas.vue?vue&type=script&lang=js&"
export * from "./ListaAulas.vue?vue&type=script&lang=js&"
import style0 from "./ListaAulas.vue?vue&type=style&index=0&id=662b0a97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b0a97",
  null
  
)

export default component.exports